import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const RequireBranchAccess = ({ children }) => {
  const { branchId } = useParams();
  const selectedBranch = localStorage.getItem('selectedBranchId');
  const resolvedBranchId = branchId || selectedBranch;

  if (!resolvedBranchId) {
    return <Navigate to="/branches" replace />;
  }

  return children;
};

export default RequireBranchAccess;
